// src/lib/service-annonces.js — L'INTERRUPTEUR UNIQUE « SERVICE D'ANNONCES EN PAUSE ».
//
// ⚠️ SOURCE UNIQUE (pas un miroir) : CJS pur (zéro import, zéro React, zéro
// Supabase). Lu côté SERVEUR par `require("../src/lib/service-annonces.js")`
// (api/scrape-prospects.js, api/melo-webhook.js, lib/prospects-store.js) et
// côté CLIENT par l'écran Logements › À démarcher. Même doctrine que
// src/lib/variables-essentielles.js : CRA interdit l'import de la racine lib/
// depuis src/, le require inverse est légal.
//
// ══ POURQUOI ════════════════════════════════════════════════════════════════
//
// Le 01/10/2026, Dimitri résilie l'abonnement au service d'annonces (Melo,
// 24 € HT/mois). Mesuré en base le même jour : 4 078 annonces sur 4 106
// viennent de lui (les 28 autres, de la recherche cartographique, n'ont rien
// ajouté depuis juin). Sans lui, la file « À démarcher » ne se remplit plus.
//
// Quand l'interrupteur est posé :
//   · le relevé de nuit n'interroge plus ce service (les autres sources
//     tournent comme avant) ;
//   · son webhook répond 200 « en pause » et n'écrit RIEN ;
//   · l'auto-masquage n'éteint pas ses annonces déjà récupérées : elles ne
//     sont plus « revues » chaque nuit, et sans cette exception elles
//     disparaîtraient toutes de l'écran en 14 jours, sans qu'aucune ne soit
//     morte — c'est la source qui s'est tue, pas l'annonce ;
//   · l'écran le dit en une phrase, sans nom de prestataire (règle 32).
//
// Rallumer = passer EN_PAUSE à false (et remettre la clé chez Vercel si elle
// a été retirée). Avant de se réabonner : voir docs/MISSIONS.md, « APRÈS LE
// LANCEMENT ».

const SERVICE_ANNONCES_EN_PAUSE = true;

/** Date de la mise en pause (ISO, pour l'écran et les journaux). */
const SERVICE_ANNONCES_PAUSE_DEPUIS = "2026-10-01";

/** Préfixe des identifiants d'annonces venues de ce service (`melo_<uuid>`). */
const PREFIXE_ANNONCES_SERVICE = "melo_";

/** La phrase affichée à l'écran — français simple, aucun nom de prestataire. */
const PHRASE_PAUSE =
  "Service d'annonces en pause : les annonces déjà récupérées restent consultables.";

/** La raison renvoyée par le serveur quand il ne fait rien (règle 23). */
const RAISON_PAUSE =
  "service d'annonces en pause depuis le 01/10/2026 (abonnement résilié) : rien n'est demandé ni enregistré";

function estAnnonceDuService(id) {
  return typeof id === "string" && id.startsWith(PREFIXE_ANNONCES_SERVICE);
}

module.exports = {
  SERVICE_ANNONCES_EN_PAUSE,
  SERVICE_ANNONCES_PAUSE_DEPUIS,
  PREFIXE_ANNONCES_SERVICE,
  PHRASE_PAUSE,
  RAISON_PAUSE,
  estAnnonceDuService,
};
